import { Box, Container, Stack, Typography } from "@mui/material";
import orderNowBg from "../Assets/images/order_now_banner.jpg";
import SEO from "../Common/SEO";
import LocationCard from "../Common/LocationCard";
import { locations } from "../locations";

const OrderNow = () => (
  <Box
    component="main"
    sx={{
      position: "relative",
      isolation: "isolate",
      minHeight: "calc(100vh - var(--header-height))",
      pt: { xs: 6, md: 8 },
      pb: { xs: 6, md: 10 },
      backgroundColor: "#20141e",
      "&::before, &::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: { xs: "440px", md: "max(36vw, 480px)" },
      },
      "&::before": {
        zIndex: -2,
        backgroundImage: `url(${orderNowBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        filter: "saturate(1.15)",
      },
      "&::after": {
        zIndex: -1,
        background:
          "linear-gradient(180deg, rgba(32, 20, 30, 0.35) 0%, rgba(32, 20, 30, 0.6) 45%, #20141e 100%)",
      },
    }}
  >
    <SEO
      title="Order Bagara's Online - Sunnyvale, San Francisco & San Jose"
      description="Choose a Bagara's location to order. Sunnyvale offers dine-in, takeout, and delivery. San Francisco is takeout and delivery. San Jose is closed — permit pending."
      canonical="https://bagaras.com/order-now"
      keywords="order Bagara's online, Bagara's Sunnyvale order, Bagara's San Francisco takeout, Indian food delivery San Francisco, Hyderabadi biryani delivery"
    />
    <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
      <Box
        sx={{
          maxWidth: 760,
          mx: "auto",
          mb: { xs: 4, md: 6 },
          px: { xs: 2.5, md: 5 },
          py: { xs: 3, md: 4 },
          textAlign: "center",
          borderRadius: "24px",
          backgroundColor: "rgba(32, 20, 30, 0.72)",
          border: "1px solid rgba(255, 255, 255, 0.14)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          boxShadow: "0 24px 48px -20px rgba(0, 0, 0, 0.7)",
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            color: "white",
            fontWeight: "bold",
            fontFamily: "Sansita Swashed",
            fontSize: { xs: "2.75rem", md: "4rem" },
            lineHeight: 1.05,
            textShadow: "0 4px 18px rgba(0, 0, 0, 0.7)",
            mb: 1.5,
          }}
        >
          Order Now
        </Typography>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            display: { xs: "none", sm: "block" },
            color: "#FFD700",
            fontWeight: 800,
            fontSize: { xs: "1.35rem", md: "1.6rem" },
            letterSpacing: "0.04em",
            textShadow: "0 2px 10px rgba(0, 0, 0, 0.6)",
            mb: 1.25,
          }}
        >
          Choose a location
        </Typography>
        <Typography
          sx={{
            display: { xs: "none", sm: "block" },
            color: "white",
            fontWeight: 600,
            fontSize: { xs: "1rem", md: "1.15rem" },
            lineHeight: 1.5,
            textShadow: "0 2px 8px rgba(0, 0, 0, 0.6)",
          }}
        >
          Sunnyvale is open for dine-in, takeout, and delivery. San Francisco is takeout and delivery only.
          San Jose is closed — permit pending.
        </Typography>
      </Box>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 3, md: 3 }}
        useFlexGap
        flexWrap="wrap"
        sx={{ "& > *": { flex: { xs: "1 1 100%", md: "1 1 280px" }, minWidth: 0 } }}
      >
        {locations.map((location) => (
          <LocationCard key={location.id} location={location} />
        ))}
      </Stack>
    </Container>
  </Box>
);

export default OrderNow;
